// libs
import React, { useState } from "react";
import styled from "@emotion/styled";

// components
import Checkbox from "shared/components/AuthModal/components/Checkbox";

// styled components
const Container = styled.div`
    font-size: 0.85rem;
    text-align: center;
    margin-bottom: 10px;

    .text {
        line-height: 14px;
    }
`;

interface ISignupPolicyProps {
    onNewsletterChecked: (newsletterSelected: boolean) => void;
}

const SIGN_UP_POLICY_TEXT =
    "I would like to receive emails about offers, new arrivals and exclusive promotions.";

const SignUpPolicy = ({ onNewsletterChecked }: ISignupPolicyProps) => {
    const [isChecked, setIsChecked] = useState(false);

    const onClick: React.MouseEventHandler<HTMLInputElement> = e => {
        // @ts-ignore
        onNewsletterChecked(e.target.checked);
        // @ts-ignore
        setIsChecked(e.target.checked);
    };

    return (
        <Container>
            <input
                type="checkbox"
                data-test="newsletter-chkbox"
                id="signup-policy-input"
                onClick={onClick}
                hidden
            />
            <label htmlFor="signup-policy-input">
                <Checkbox checked={isChecked} />
                <span className="text">{SIGN_UP_POLICY_TEXT}</span>
            </label>
        </Container>
    );
};

export default SignUpPolicy;
